import { render, staticRenderFns } from "./GoodsTransfer.vue?vue&type=template&id=1b4e1ac6&scoped=true"
import script from "./GoodsTransfer.vue?vue&type=script&lang=js"
export * from "./GoodsTransfer.vue?vue&type=script&lang=js"
import style0 from "./GoodsTransfer.vue?vue&type=style&index=0&id=1b4e1ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e1ac6",
  null
  
)

export default component.exports